import { render, staticRenderFns } from "./QuestionTemplateEditPage.vue?vue&type=template&id=0e62f1b1&scoped=true&"
import script from "./QuestionTemplateEditPage.vue?vue&type=script&lang=ts&"
export * from "./QuestionTemplateEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionTemplateEditPage.vue?vue&type=style&index=0&id=0e62f1b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e62f1b1",
  null
  
)

export default component.exports